import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/images/dreAvatar.png'


const _hoisted_1 = { class: "dre-tray-message" }
const _hoisted_2 = {
  key: 0,
  class: "dre-tray-message__avatar"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  loading: "lazy"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "dre-tray-message__message" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "dre-tray-message__avatar"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppAvatar = _resolveComponent("AppAvatar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["dre-tray-message__time", { 'user': !_ctx.isDre }])
    }, _toDisplayString(_ctx.timeDiffCalc(_ctx.message.time)), 3),
    _createElementVNode("div", {
      class: _normalizeClass(["dre-tray-message__content", { 'user': !_ctx.isDre }])
    }, [
      (_ctx.isDre)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", {
          class: _normalizeClass(["dre-tray-message__message__bubble", { 'user': !_ctx.isDre }])
        }, _toDisplayString(_ctx.message.message), 3),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.message.pills, (pill, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "dre-tray-message__message__pill",
            onClick: ($event: any) => (_ctx.$emit('on-pill-select', pill))
          }, _toDisplayString(pill.text), 9, _hoisted_6))
        }), 128))
      ]),
      (!_ctx.isDre)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_AppAvatar, {
              user: _ctx.userProfile,
              size: "normal"
            }, null, 8, ["user"])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}